module.exports = __webpack_public_path__ + "media/images/alumni/bg-fb4f21714e7fc8a286a81f296bc7efc5.png";